import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

window.mixpanel.track_links('a', 'Clicked link');

window.mixpanel.time_event('Closed app');

window.onbeforeunload = function (e) {
  window.mixpanel.track('Closed app');
};



// WEBPACK FOOTER //
// ./src/index.js